export default {"src":"/_next/static/media/blast.e39807f8.svg","height":215,"width":215,"blurWidth":0,"blurHeight":0};